var router = require('pjax').Router;
var index = require('./index.js');
var form = require('./form.js');

router.get('award', index);
router.get('award/:any', form);
